module.exports = __webpack_public_path__ + "static/media/cedula4.699e6017.png";